export default {"src":"/_next/static/media/coins_24.c63edb99.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};